import React from "react";
import * as Popover from "@radix-ui/react-popover";
import { CircleDot, PlugZap } from "lucide-react";
import { useLocation } from "react-router-dom";

const UNAVAILABLE = ["Walmart Marketplace live feed", "Walmart Connect (PPC)", "Stripe billing", "Resend email", "Supabase database"];

// Deal Flow is established as live Mongo-backed with no fixtures by PR #62, so
// its API truthfully reports data_mode=live / demo_fixtures=false. Suppress the
// badge there only. Other routes keep their existing badge behavior unless their
// own data contract explicitly marks them live.
const LIVE_DATA_ROUTES = ["/app/research/quick-winner", "/app/research/deal-flow"];

// Compact "Demo data" indicator with an explanatory popover. No page-wide banner.
export function DataModeBadge({ compact }) {
  const location = useLocation();
  const isLiveRoute = LIVE_DATA_ROUTES.some((r) => (location?.pathname || "").startsWith(r));
  if (isLiveRoute) return null;
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button data-testid="data-mode-badge"
          className="inline-flex items-center gap-1.5 rounded-ctrl border border-edge-subtle bg-surface-0 px-2 h-8 text-micro font-medium text-ink-secondary hover:bg-surface-2">
          <CircleDot className="h-3.5 w-3.5 text-amber-500" /> Demo data
        </button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content align="end" sideOffset={8} className="z-[80] w-72 bg-surface-0 border border-edge-subtle rounded-panel shadow-menu p-3 ez-rise-in">
          <div className="flex items-center gap-2 text-compact font-medium text-ink-primary"><PlugZap className="h-4 w-4 text-amber-500" />Demonstration data</div>
          <p className="text-micro text-ink-secondary mt-1">All values are illustrative — never live. These integrations are not connected:</p>
          <ul className="mt-2 space-y-1">
            {UNAVAILABLE.map((u) => <li key={u} className="text-micro font-mono text-ink-muted flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-amber-500" />{u}</li>)}
          </ul>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}

// Deprecated page-wide banner removed — kept as no-op to avoid stale imports.
export function FixtureBanner() { return null; }
